import { cartApi } from "@api";
import { IFareCart } from "@interfaces";
import { useEffect, useState } from "react";
import { find } from "lodash";
import Dropdown from "src/Module/Cart/CustomDropdown";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export interface TravellerDetails {
    first_name: string | null;
    last_name: string | null;
    phone_number: number;
    country_code: string;
    email: string;
    id: string;
}
export interface Suggestion {
    first_name: string | null;
    last_name: string | null;
    phone_number: number;
    country_code: string;
    email: string;
    id: string;
}
interface AddTravellerProps {
    index: number;
    traveller: TravellerDetails | null;
    onAddTraveller: () => void;
    onRemoveTraveller: () => void;
    onAddTravellerClick: (index: number) => void; // New prop
    bookingItem: IFareCart;
    onPickupLocationChange: (value: {
        pickupId: string | number;
        pickupLocation: string;
        pickupTime: string;
    }) => void;
    onTimeChange: (value: { commences: string; bookingTimeId: string | number }) => void;
    prefilledPickupLocation?: {
        pickupId: string | number;
        pickupLocation: string;
        pickupTime: string;
    };
    prefilledTime?: {
        commences: string;
        bookingTimeId: string | number;
    };
    onAddToSuggestions: (removedTraveller: Suggestion) => void;
}

const sanitizeId = (id: string | number | undefined | null): string => String(id ?? "").trim();

// const transformOptions = (
//     options: { displayName?: string; name?: string; externalId?: string }[],
//     type: "pickup" | "time",
// ) =>
//     options.map((option) => ({
//         label: option.displayName ?? option.name ?? "Unknown",
//         value: JSON.stringify(
//             type === "pickup"
//                 ? {
//                     pickupId: sanitizeId(option.externalId),
//                     pickupLocation: option.displayName ?? option.name ?? "Unknown Location",
//                     pickupTime: "",
//                 }
//                 : {
//                     commences: option.displayName,
//                     bookingTimeId: sanitizeId(option.externalId),
//                 },
//         ),
//     }));

export const AddTravellerInformation = ({
    index,
    traveller,
    onAddTraveller,
    onRemoveTraveller,
    onAddTravellerClick,
    bookingItem,
    onPickupLocationChange,
    onTimeChange,
    prefilledPickupLocation,
    prefilledTime,
    onAddToSuggestions,
}: AddTravellerProps) => {
    const [selectedPickupLocation, setSelectedPickupLocation] = useState<{
        pickupId: string | number;
        pickupLocation: string;
        pickupTime: string;
    } | null>(null);

    const [selectedTime, setSelectedTime] = useState<{
        commences: string;
        bookingTimeId: string | number;
    } | null>(null);

    const [availableOptions, setAvailableOptions] = useState<{
        timeOptions: { label: string; value: string }[];
        pickupOptions: { label: string; value: string }[];
    }>({ timeOptions: [], pickupOptions: [] });

    const [isLoadingPickupOptions, setIsLoadingPickupOptions] = useState(false);

    const productDetails = find(
        bookingItem.product?.json?.faresprices,
        (product) =>
            String(product.productPricesDetailsId) === String(bookingItem.product_price_details_id),
    );

    // const fetchOptions = (type: "pickup" | "time") => {
    //     // if (productDetails?.bookingSystem === "Respaxv2") {
    //     //     const fieldName = type === "pickup" ? "pickupid" : "timeid";
    //     //     const field = find(bookingItem.availability?.fields, (f) =>
    //     //         f.name.toLowerCase().includes(fieldName),
    //     //     );
    //     //     return transformOptions(field?.options || [], type);
    //     // } else {
    //     //     if (type === "pickup") {
    //     //         return (
    //     //             bookingItem.booking_details?.pickupLocations?.map(
    //     //                 (location: IPickupLocationFare) => ({
    //     //                     label: location.PickupLocation ?? "Unknown Location",
    //     //                     value: JSON.stringify({
    //     //                         pickupId: sanitizeId(location.PickupID),
    //     //                         pickupLocation:
    //     //                             location.PickupLocation?.trim() ?? "Unknown Location",
    //     //                         pickupTime: location.PickupTime,
    //     //                     }),
    //     //                 }),
    //     //             ) || []
    //     //         );
    //     //     } else {
    //     //         return (
    //     //             bookingItem.booking_details?.bookingTimes?.map((time) => ({
    //     //                 label: time.BookingTime,
    //     //                 value: JSON.stringify({
    //     //                     commences: time.BookingTime,
    //     //                     bookingTimeId: sanitizeId(time.BookingTimeID),
    //     //                 }),
    //     //             })) || []
    //     //         );
    //     //     }
    //     // }
    // };

    // --- PREFILL LOGIC ---
    useEffect(() => {
        if (traveller && prefilledPickupLocation && !selectedPickupLocation) {
            const prefilled = {
                pickupId: sanitizeId(prefilledPickupLocation.pickupId),
                pickupLocation: prefilledPickupLocation.pickupLocation,
                pickupTime: prefilledPickupLocation.pickupTime,
            };
            setSelectedPickupLocation(prefilled);
            onPickupLocationChange(prefilled);
        }
    }, [traveller, prefilledPickupLocation, selectedPickupLocation, onPickupLocationChange]);

    useEffect(() => {
        if (traveller && prefilledTime && !selectedTime) {
            const prefilled = {
                commences: prefilledTime.commences,
                bookingTimeId: sanitizeId(prefilledTime.bookingTimeId),
            };
            setSelectedTime(prefilled);
            onTimeChange(prefilled);
        }
    }, [traveller, prefilledTime, selectedTime, onTimeChange]);

    // --- FETCH OPTIONS ---
    useEffect(() => {
        // if (traveller) {
        //     const timeOptions = fetchOptions("time");
        //     const pickupOptions = fetchOptions("pickup");

        //     setAvailableOptions({ timeOptions, pickupOptions });

        //     // Automatically pick the single time option for IBIS
        //     if (productDetails?.bookingSystem === "IBIS" && timeOptions.length === 1) {
        //         const singleTimeOption = JSON.parse(timeOptions[0].value);
        //         setSelectedTime(singleTimeOption);
        //         onTimeChange(singleTimeOption);
        //     }

        //     // Handle IBIS case: Fetch time and pickup options dynamically
        //     if (productDetails?.bookingSystem === "IBIS") {
        //         setIsLoadingPickupOptions(true); // Set loading state
        //         cartApi
        //             .confirmAvailability(
        //                 bookingItem.product_price_details_id,
        //                 bookingItem.booking_date,
        //             )
        //             .then((response) => {
        //                 const fields = response.data.fields || [];

        //                 // Extract time options
        //                 const timeField = find(
        //                     fields,
        //                     (field: any) => field.name.toLowerCase() === "timeid",
        //                 );
        //                 if (timeField?.options) {
        //                     const fetchedTimeOptions = transformOptions(timeField.options, "time");
        //                     setAvailableOptions((prev) => ({
        //                         ...prev,
        //                         timeOptions: fetchedTimeOptions,
        //                     }));

        //                     // Automatically pick the single time option for IBIS
        //                     if (fetchedTimeOptions.length === 1) {
        //                         const singleTimeOption = JSON.parse(fetchedTimeOptions[0].value);
        //                         setSelectedTime(singleTimeOption);
        //                         onTimeChange(singleTimeOption);
        //                     }
        //                 }

        //                 // Extract pickup options
        //                 const pickupField = find(
        //                     fields,
        //                     (field: any) => field.name.toLowerCase() === "pickupid",
        //                 );
        //                 if (pickupField?.options) {
        //                     const fetchedPickupOptions = transformOptions(
        //                         pickupField.options,
        //                         "pickup",
        //                     );
        //                     setAvailableOptions((prev) => ({
        //                         ...prev,
        //                         pickupOptions: fetchedPickupOptions,
        //                     }));
        //                 }
        //             })
        //             .catch((error) => {
        //                 console.error("Error fetching options for IBIS:", error);
        //             })
        //             .finally(() => {
        //                 setIsLoadingPickupOptions(false); // Reset loading state
        //             });
        //     }
        // }
    }, [
        bookingItem.product_price_details_id,
        bookingItem.booking_date,
        productDetails?.bookingSystem,
        traveller,
    ]);

    // --- EVENT HANDLERS ---
    const handleTimeSelection = (value: string) => {
        const parsedValue = JSON.parse(value);
        setSelectedTime(parsedValue);
        onTimeChange(parsedValue);

        // Skip API call for non-Respaxv2 systems
        if (productDetails?.bookingSystem !== "Respaxv2") {
            return;
        }

        // Clear existing pickup options and set loading state
        setAvailableOptions((prev) => ({ ...prev, pickupOptions: [] }));
        setIsLoadingPickupOptions(true);

        // Fetch pickup options for Respaxv2 system
        cartApi
            .confirmAvailability(
                bookingItem.product_price_details_id,
                bookingItem.booking_date,
                parsedValue.bookingTimeId,
            )
            // .then((response) => {
            //     // const fields = response.data.fields || [];
            //     // const pickupField = find(fields, (field: any) =>
            //     //     field.name.toLowerCase().includes("pickupid"),
            //     // );

            //     // if (pickupField?.options) {
            //     //     const pickupOptions = transformOptions(pickupField.options, "pickup");
            //     //     setAvailableOptions((prev) => ({ ...prev, pickupOptions }));
            //     // }
            // })
            .catch((error) => {
                console.error("Error confirming availability:", error);
            })
            .finally(() => setIsLoadingPickupOptions(false));
    };

    // Automatically select the single time option if available
    useEffect(() => {
        if (availableOptions.timeOptions.length === 1 && !selectedTime) {
            const singleTimeOption = JSON.parse(availableOptions.timeOptions[0].value);
            setSelectedTime(singleTimeOption);
            onTimeChange(singleTimeOption);
        }
    }, [availableOptions.timeOptions, selectedTime, onTimeChange]);

    const handlePickupSelection = (value: string) => {
        const parsedValue = JSON.parse(value);
        setSelectedPickupLocation(parsedValue);
        onPickupLocationChange(parsedValue);
    };

    const selectedTimeValue =
        find(availableOptions.timeOptions, (option) => {
            const parsed = JSON.parse(option.value);
            return sanitizeId(parsed.bookingTimeId) === sanitizeId(selectedTime?.bookingTimeId);
        })?.value || "";

    const selectedPickupValue =
        find(availableOptions.pickupOptions, (option) => {
            const parsed = JSON.parse(option.value);
            return sanitizeId(parsed.pickupId) === sanitizeId(selectedPickupLocation?.pickupId);
        })?.value || "";
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        document.body.style.overflow = isBottomSheetOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isBottomSheetOpen]);
    const numPax = productDetails?.numPax ? Number(productDetails.numPax) : 1;

    const travellers = traveller?.first_name?.split(", ") || [];

    const handleOpenBottomSheet = () => {
        setIsBottomSheetOpen(true);
        setIsOpen(true);
    };

    const handleRemoveIndividualTraveller = (name: string) => {
        const updatedTravellers = travellers.filter((t) => t !== name).join(", ");

        const removedTraveller = traveller && {
            first_name: name,
            last_name: "",
            phone_number: traveller.phone_number,
            country_code: traveller.country_code,
            email: traveller.email,
            id: traveller.id,
        };

        if (updatedTravellers) {
            onPickupLocationChange({
                ...selectedPickupLocation,
                pickupId: selectedPickupLocation?.pickupId || "",
                pickupLocation: selectedPickupLocation?.pickupLocation || "",
                pickupTime: selectedPickupLocation?.pickupTime || "",
            });

            if (traveller) {
                traveller.first_name = updatedTravellers;
            }
        } else {
            onRemoveTraveller();
        }

        if (removedTraveller) {
            onAddToSuggestions(removedTraveller);
        }
    };

    return (
        <>
            <TravellerContainer>
                <div className="listCount">{index + 1}</div>
                <Traveller>
                    {travellers.length > 1 ? (
                        <div
                            style={{
                                display: "flex",
                                flex: 1,
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                            onClick={handleOpenBottomSheet}
                        >
                            {travellers.join(", ")} <StyledArrow isOpen={isOpen} />
                        </div>
                    ) : traveller ? (
                        <div
                            style={{
                                display: "flex",
                                flex: 1,
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            {traveller.first_name} {traveller.last_name}
                            <button type="button" onClick={onRemoveTraveller}>
                                <img src="/images/deleteSvgButton.svg" alt="delete" />
                            </button>
                        </div>            
                    ) : (
                        <div className="addTraveller" onClick={onAddTraveller}><img src="/images/Add.svg" alt="add" /><h3>Add Traveller(s)</h3></div>
                    )}
                </Traveller>
            </TravellerContainer>
            {numPax > 1 &&
                traveller?.first_name &&
                traveller.first_name.split(", ").length < numPax && (
                    <div style={{ alignSelf: "flex-end", marginTop: "10px" }}>
                        <button
                            style={{ fontSize: "14px", color: "#31B4B9", fontWeight: "600" }}
                            onClick={() => onAddTravellerClick(index)}
                        >
                            +Add
                        </button>
                    </div>
                )}

            {isBottomSheetOpen && (
                <Overlay onClick={() => setIsBottomSheetOpen(false)}>
                    <div className="bottomSheet">
                        <h4>Selected Travellers</h4>
                        <ul>
                            {travellers.map((name, idx) => (
                                <li key={idx}>
                                    {name}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveIndividualTraveller(name)}
                                    >
                                        <img src="images/deleteSvg.svg" alt="delete" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Overlay>
            )}
            {traveller && (
                <TravellerInfo>
                    <h6>Booking Details</h6>
                    {productDetails?.bookingSystem === "IBIS" && isLoadingPickupOptions ? (
                        <p>Loading time and pickup options...</p>
                    ) : (
                        <>
                            <Dropdown
                                key={`time-${index}`}
                                options={availableOptions.timeOptions}
                                value={selectedTimeValue}
                                onChange={handleTimeSelection}
                                placeholder="Pick Up Time"
                            />
                            <Dropdown
                                key={`location-${index}`}
                                options={availableOptions.pickupOptions}
                                value={selectedPickupValue}
                                onChange={handlePickupSelection}
                                placeholder="Pick Up Location"
                            />
                        </>
                    )}
                </TravellerInfo>
            )}
        </>
    );
};

// --- STYLED COMPONENTS ---
const TravellerContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .listCount {
        width: 32px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        background-color: #f4f6f7;
        border-radius: 50%;
        font-weight: 600;
    }
`;

const Traveller = styled.div`
    flex: 1;
    border: 1px solid #c3c9d0;
    border-radius: 8px;
    gap: 10px;
    padding: 8px 20px;
    color: #31b4b9;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Plus Jakarta Sans;
    height:48px;

    .addTraveller{
        display: flex;
        align-items: center;
        justify-content: center;
        gap : 6px;
        h3{
            font-size: 16px;
            font-weight: 600;
        }
    }
`;

const TravellerInfo = styled.div`
    margin-left: 40px;
    display: flex;
    gap: 8px;
    flex-direction: column;
    margin-top: 10px;
    h6 {
        font-size: 14px;
    }
`;
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    .bottomSheet {
        background: #fff;
        width: 100%;
        max-height: 50%;
        border-radius: 16px 16px 0 0;
        padding: 16px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        overflow-y: auto;

        h4 {
            margin-bottom: 16px;
        }

        ul {
            list-style: none;
            padding: 0;

            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 10px;

                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
`;

const StyledArrow = styled(KeyboardArrowDownIcon) <{ isOpen: boolean }>`
    transition: transform 0.5s;
    transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
    color: #31b4b9;
`;
